/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportObject
 */
export interface ReportObject {
    /**
     * 
     * @type {string}
     * @memberof ReportObject
     */
    base64: string;
    /**
     * 
     * @type {string}
     * @memberof ReportObject
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReportObject
     */
    contentType: string;
}

/**
 * Check if a given object implements the ReportObject interface.
 */
export function instanceOfReportObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "base64" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "contentType" in value;

    return isInstance;
}

export function ReportObjectFromJSON(json: any): ReportObject {
    return ReportObjectFromJSONTyped(json, false);
}

export function ReportObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base64': json['Base64'],
        'name': json['Name'],
        'contentType': json['ContentType'],
    };
}

export function ReportObjectToJSON(value?: ReportObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Base64': value.base64,
        'Name': value.name,
        'ContentType': value.contentType,
    };
}

